import React from 'react';
import useSearchParams from '../useSearchParams';

export const ScoreFilter: React.FC = () => {
  const {query, setQuery} = useSearchParams();
  const selectedScores = query.selectedScores;
  const direction = query.direction;

  const handleScoreToggle = (score: string) => {
    const newSelectedScores = selectedScores.includes(score)
      ? selectedScores.filter((s) => s !== score)
      : [...selectedScores, score];

    setQuery({selectedScores: newSelectedScores});
  };

  const handleDirectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setQuery({direction: e.target.value || undefined});
  };

  const scores = ['A', 'B', 'C', 'D'];

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-bold text-c-text-primary">スコア</span>
      <div className="relative">
        <select 
          value={direction || ''}
          onChange={handleDirectionChange}
          className="h-8 px-2 pr-6 text-xs font-bold border border-c-border rounded bg-white text-c-text-primary appearance-none min-w-[80px]"
        >
          <option value="">すべて</option>
          <option value="up">上昇</option>
          <option value="down">下降</option>
        </select>
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.33 2.67L4 5.33L6.67 2.67"
              stroke="#4D4D4D"
              strokeWidth="1.5"
              fill="none"
            />
          </svg>
        </div>
      </div>
      <div className="flex gap-4">
        {scores.map((score) => (
          <div key={score} className="flex items-center gap-1">
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={selectedScores.includes(score)}
                onChange={() => handleScoreToggle(score)}
                className="sr-only"
              />
              <div
                className={`w-4 h-4 rounded border-2 flex items-center justify-center ${
                  selectedScores.includes(score)
                    ? 'bg-blue-600 border-blue-600'
                    : 'bg-white border-gray-300'
                }`}>
                {selectedScores.includes(score) && (
                  <svg
                    width="12"
                    height="10"
                    viewBox="0 0 12 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10.5 1L4.25 7.25L1.5 4.5"
                      stroke="white"
                      strokeWidth="2"
                      fill="none"
                    />
                  </svg>
                )}
              </div>
            </label>
            <span className="text-xs text-c-text-secondary">{score}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
